import { render, staticRenderFns } from "./detail-kiosk-warehouse.vue?vue&type=template&id=57d39f79&"
import script from "./detail-kiosk-warehouse.vue?vue&type=script&lang=js&"
export * from "./detail-kiosk-warehouse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports